import { useProjectContext } from '@atlassian/jira-providers-project-context';
import { getParentProduct } from '../utils';

export const useParentProduct = () => {
	const { data } = useProjectContext();
	const projectType = data?.projectType;
	return getParentProduct(projectType);
};
